import { AutogiroRemindersSettings } from 'src/shared/components/organisms/autogiroRemindersSettings';
import { updateFundraiserAutogiroReminderSettings } from 'src/shared/services/fundraiserService';
import { FundraiserResponse } from '../models/fundraiserResponse';

type FundraiserAutogiroRemindersProps = {
  fundraiserResponse: FundraiserResponse;
};

// Platshållare som kan användas i ämne och text för påminnelserna.
const reminderCustomFields = [
  { label: 'Namn', value: '[name]' },
  { label: 'Belopp', value: '[amount]' },
  { label: 'Organisation', value: '[organization]' },
  { label: 'Signeringslänk', value: '[signingLink]' },
];

export const FundraiserAutogiroReminders = (props: FundraiserAutogiroRemindersProps) => {
  const { fundraiserResponse } = props;

  return (
    <AutogiroRemindersSettings
      initialValues={fundraiserResponse}
      customFields={reminderCustomFields}
      translationPrefix='fundraiser:autogiroReminders'
      onSave={(settings) => updateFundraiserAutogiroReminderSettings(fundraiserResponse.fundraiser_id, settings)}
    />
  );
};
